module.exports = __webpack_public_path__ + "img/national-qualification-level-4.92135583.jpg";